import API from "../api.js"
let schoolSubjectList=[]
export async function getRegion(api, level, parentId) {
	try {
		let res = await api.API.get(api.API.admin.getRegionList, {
			level: level,
			parentId: parentId
		})
		let list = res.data.data.sort((a, b) => Number(a.adcode) - Number(b.adcode))
		
		
		return list

	} catch (e) {
		
		return []
	}
}
//搜索教育局
export async function forEduName(api, name) {
	if (!name || name === "") return []
	try {
		let res = await api.API.get(api.API.admin.getRemoteSearch, {
			keyword: name
		})
		let list = res.data.data
		return list

	} catch (e) {

		return []
	}
}
export function forGradeList() {
	let list = []
	var name = ['请选择', '一', '二', '三', '四', '五', '六', '七', '八', '九', '高一', '高二', '高三']
	for (let i = 0; i < name.length; i++) {
		var label = i === 0 ? `${name[i]}` : `${name[i]}年级`
		list.push({
			value: i,
			label: label
		})
	}
	return list
}
export async function schoolSubject() {
	try {
		let res = await API.get(API.admin.getschoolSubjectList, {
			schoolId: localStorage.getItem('orgId'),
			pageNum: 1,
			pageSize: 100
		})
		
		let list = res.data?.data?.records.map(v => {
			v.value = v.subjectId
			v.label = v.subjectName
			v.roleType = 10
			return {
				...v
			}
		})?.sort((a, b) => a.subjectId - b.subjectId)
		localStorage.setItem('subjectList',JSON.stringify(list))
		return list ||[]
	} catch (error) {
		return []
	}

}
export async  function teacherSubject() {
	//管理员1，子管理员2  校领导3   部门人员4   班主任5   副班主任6   普通7
	let SubjectList=await schoolSubject()
	console.log('SubjectList',SubjectList)
	let newlist=[{
			value: 0,
			label: "班主任",
			roleType: 8,
			subjectId:0,
			subjectName:"班主任"
		}, {
			value: 0,
			label: "副班主任",
			roleType: 9,
			subjectId:0,
			subjectName:"副班主任"
		}]
	return [...newlist,...SubjectList]
	
}

export function forSubjectList() {
	const subjectList = [{
			value: '-1',
			label: "全部学科",
			roleType: '0'
		},
		{
			value: '1',
			label: "语文",
			roleType: 10
		},
		{
			value: '2',
			label: "数学",
			roleType: 10
		},
		{
			value: '3',
			label: "英语",
			roleType: 10
		},
		{
			value: '4',
			label: "物理",
			roleType: 10
		},
		{
			value: '5',
			label: "化学",
			roleType: 10
		},
		{
			value: '6',
			label: "历史",
			roleType: 10
		},
		{
			value: '7',
			label: "地理",
			roleType: 10
		},
		{
			value: '8',
			label: "生物",
			roleType: 10
		},
		{
			value: '9',
			label: "思想政治",
			roleType: 10
		},
		{
			value: '10',
			label: "科学",
			roleType:10
		},
		{
			value: '11',
			label: "历史与社会",
			roleType: 10
		},
		{
			value: '12',
			label: "道德与法治",
			roleType: 10
		},
		{
			value: '16',
			label: "政治",
			roleType: 10
		},
	]
	return subjectList
}